import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subject, Subscription } from 'rxjs';
import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  SimpleChange,
  SimpleChanges,
  Input,
} from '@angular/core';
import { LazyLoadEvent, TreeNode, Checkbox, MessageService, SelectItem, Table } from 'primeng';
import { Message } from '../../classes/Message';
import { ISystemSettings } from '../../interfaces/system-settings';
import { AdditionalChargeService } from '../../services';
import { JobsService } from '../../services';
import { MapService } from '../../services';
import { ReportService } from '../../services';
import { SettingsService } from '../../services';
import { TaskService } from '../../services';
import { UserService } from '../../services';
import { VmeInboxJobsService } from '../../services';
import { BaseReportComponent } from './base-report.component';
import moment from 'moment';

export enum JobStatus {
  Completed = 1,
  Invoiced = 2,
  Closed = 3,
  Cancelled = 4,
  Created = 5,
  Started = 6,
}

export enum TransactionLineDTOType {
  Summary = 1,
  CustomerCost = 2,
  SupplierPayment = 3,
  Expense = 4,
}

export enum TransactionTypeEnum {
  Customer = 1,
  Supplier = 2,
  Engineius = 3,
}

@Component({
  selector: 'transaction-lines-report',
  templateUrl: './transaction-lines-report.component.html',
  styleUrls: ['./transaction-lines-report.component.css'],
})
export class TransactionLinesReportComponent extends BaseReportComponent<any, any, any> {
  public organisationTypeId: number = 0;
  public isBusyOrganisationType: boolean = false;
  public TransactionLineType = TransactionLineDTOType;
  public statusClosed = JobStatus.Closed;
  public selectedJob: any;
  public items: TreeNode[] = [];
  public cols: any[];
  public useJobCompletedDate: boolean = false;
  public includeEngineiusTransactions: boolean = false;
  public showProgressBar: boolean = false;
  public confirmationNotesVisible: boolean = false;
  public verifyUnconfirmVisible: boolean = false;
  public transactionLineItem: any;

  public customers: SelectItem[] = [];
  public additionalChargeTypes: SelectItem[] = [];

  public noteImageUrl = 'assets/images/note.png';
  public radioButtonVal: string = 'showAll';
  private defaultMarginPercent: number = 29;

  @ViewChild('dt') dataTable: Table;

  constructor(
    reportService: ReportService<any, any>,
    private userService: UserService,
    private mapService: MapService,
    private taskService: TaskService,
    private router: Router,
    private ref: ChangeDetectorRef,
    private jobService: JobsService,
    private messageService: MessageService,
    private vmeInboxjobsService: VmeInboxJobsService,
    private additionalChargeService: AdditionalChargeService,
    private settingsService: SettingsService,
  ) {
    super(reportService, false);
    reportService.url = '/api/report/transactionlines';
  }

  ngOnInit() {
    super.ngOnInit();
    this.initializeCurrentUserOrgType();

    this.vmeInboxjobsService.getCustomers().then((res) => {
      var l = [];
      if (res != null) res.forEach((item) => l.push({ label: item.name, value: item.id }));
      this.customers = l;
    });

    this.additionalChargeService.getAdditionalChargeTypes().then((result) => {
      this.additionalChargeTypes = [];
      result.forEach((res) => {
        if (this.organisationTypeId != 3 || res.showToSupplier)
          this.additionalChargeTypes.push({ label: res.chargeType, value: res.id });
      });
    });

    this.cols = [
      { field: 'confirmed', header: 'Confirmed', width: '70px' },
      { field: 'completedDate', header: 'Completed Date', width: '170px' },
      { field: 'jobStatus', header: 'Job Status' },
      { field: 'engineiusStatus', header: 'Engineius Status' },
      { field: 'jobRef', header: 'Job No' },
      { field: 'orderRef', header: 'Order No' },
      { field: 'vehicles', header: 'Vehicle Registration' },
      { field: 'movementType', header: 'Movement Type' },
      { field: 'originalCustomerPrice', header: 'Original Cust Fee' },
      { field: 'customerPrice', header: 'Cust Fee', width: '100px' },
      { field: 'supplierPrice', header: 'Supp Fee', width: '100px' },
      { field: 'customerName', header: 'Customer Name' },
      { field: 'supplierName', header: 'Supplier Name' },
      { field: 'profitLossAmount', header: 'P/L' },
      { field: 'profitLossPercentage', header: 'P/L (%)' },
      { field: 'transactionType', header: 'Type' },
      { field: 'invoiceNumber', header: 'Invoice Number' },
      { field: 'invoiceDate', header: 'Invoice Date' },
    ];

    this.settingsService.GetSystemSettings().then((data: ISystemSettings) => {
      this.defaultMarginPercent = (data && data.defaultMarginPercent) || 20;
    });
  }

  public initializeCurrentUserOrgType() {
    this.isBusyOrganisationType = true;
    this.userService
      .getCurrentUserOrg()
      .then((organisation) => {
        this.isBusyOrganisationType = false;
        if (organisation) {
          this.organisationTypeId = organisation.organisationTypeId;
        }
      })
      .catch((x) => {
        this.isBusyOrganisationType = false;
      });
  }

  public callbackLoadFilterParam() {}

  initDefaultFilter() {
    super.initDefaultFilter();
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: '',
      sortOrder: 1,
      filters: {
        dateFrom: {},
        dateTo: {},
        useJobCompletedDate: { value: true },
        includeEngineiusTransactions: { value: false },
        showConfirmedOnly: { value: false },
        showUnconfirmedOnly: { value: false },
        showAll: { value: true },
        customerIdList: { value: null },
        additionalChargeTypeIdList: { value: null },
        uninvoicedTransactions: { value: false },
      },
    };

    this.filterVal.filters.dateTo.value = moment().toDate();
    this.filterVal.filters.dateFrom.value = moment().startOf('month').toDate();
  }

  checkDownloadReport() {
    let outOfRange: boolean =
      this.isEmptyObject(this.filterVal.filters.dateFrom) &&
      this.isEmptyObject(this.filterVal.filters.dateTo);

    var from = moment(this.filterVal.filters.dateFrom.value);
    var to = moment(this.filterVal.filters.dateTo.value);
    var diff = to.diff(from, 'months');

    outOfRange = outOfRange || Math.abs(diff) > 12;

    // ensure date range is no longer than one year before downloading
    if (outOfRange) {
      this.messageService.add(
        Message.Error(
          'Please ensure the date range for the report is less than a year',
          'Invalid Date Range',
        ),
      );
      return;
    }

    this.doDownload();
  }

  confirmedChange(rowData, confirmedCheckbox) {
    //console.log("rowData current: ", rowData.confirmed, " - checkbox status = ", confirmedCheckbox.checked);
    this.transactionLineItem = rowData;

    if (rowData.confirmed && !confirmedCheckbox.checked) {
      this.verifyUnconfirmVisible = true;
    }

    this.transactionLineItem.confirmed = confirmedCheckbox.checked;
    this.confirmationNotesVisible = confirmedCheckbox.checked;
  }

  saveConfirmation() {
    this.confirmationNotesVisible = false;
    this.verifyUnconfirmVisible = false;

    // update job history
    var jobMsg = `Job confirmation status was changed to ${
      this.transactionLineItem.confirmed ? 'Yes' : 'No'
    } - [Notes: ${this.transactionLineItem.notes}]`;
    this.jobService
      .addHistory({
        jobId: this.transactionLineItem.id,
        note: jobMsg,
        noteArea: 'Cost Confirmation',
        viewIsEngineius: true,
        viewIsCustomer: false,
        viewIsSupplier: false,
        createdOn: moment().format('YYYY-MM-DD HH:mm'),
      })
      .then((result) => {})
      .catch((ex) => {
        this.messageService.add(
          Message.Error(
            'An error occurred while updating the job history, auditing will be lost for this action',
            'Add Job History',
          ),
        );
      });

    if (!this.transactionLineItem.confirmed) {
      this.transactionLineItem.notes = null;
      this.transactionLineItem.confirmedByUser = null;
      this.transactionLineItem.confirmedDateTime = null;
    }

    this.reportService
      .updateTransactionLineData(this.transactionLineItem)
      .then((res) => {
        if (res) {
          this.transactionLineItem.confirmedByUser = res.confirmedByUser;
          this.transactionLineItem.confirmedDateTime = res.confirmedDateTime;
        }
      })
      .catch((ex) => {
        this.messageService.add(
          Message.Error(
            'An error occurred while updating the confirmation status of the job',
            'Confirm Job',
          ),
        );
      });
  }

  cancelConfirmation() {
    this.transactionLineItem.confirmed = true;
    this.verifyUnconfirmVisible = false;
    this.ngOnInit();
  }

  private reportSubscription: Subscription;
  doDownload() {
    this.showProgressBar = true;
    this.reportSubscription = this.downloadReport().subscribe(() => {
      this.showProgressBar = false;
    });
  }

  cancelReport() {
    this.showProgressBar = false;
    // todo: cancellation token is not working when unsubscribing here as the service is still subscribed..
    //this.addValidationMessage({ severity: 'info', summary: 'Report Cancelled', detail: 'Downloading report process has been cancelled' });
    //this.reportSubscription.unsubscribe();
  }

  isEmptyObject(obj: any) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  getProfitLossIndicatorClass(profitLossAmount) {
    var result;
    if (!isNaN(Number(profitLossAmount))) {
      profitLossAmount = profitLossAmount * 100;
      profitLossAmount = parseFloat(profitLossAmount);
      switch (true) {
        case profitLossAmount < -100:
          result = { 'darkest-red': true };
          break;
        case profitLossAmount < -80 && profitLossAmount >= -100:
          result = { 'darker-red': true };
          break;
        case profitLossAmount < -60 && profitLossAmount >= -80:
          result = { 'dark-red': true };
          break;
        case profitLossAmount < -40 && profitLossAmount >= -60:
          result = { red: true };
          break;
        case profitLossAmount < -20 && profitLossAmount >= -40:
          result = { 'medium-red': true };
          break;
        case profitLossAmount <= 0 && profitLossAmount >= -20:
          result = { 'light-red': true };
          break;
        case profitLossAmount > 0 && profitLossAmount <= 20:
          result = { 'dark-orange': true };
          break;
        case profitLossAmount > 20 && profitLossAmount <= this.defaultMarginPercent:
          result = { orange: true };
          break;
        case profitLossAmount > this.defaultMarginPercent && profitLossAmount <= 40:
          result = { 'light-green': true };
          break;
        case profitLossAmount > 40 && profitLossAmount <= 60:
          result = { green: true };
          break;
        case profitLossAmount > 60 && profitLossAmount <= 80:
          result = { 'dark-green': true };
          break;
        case profitLossAmount > 80 && profitLossAmount <= 100:
          result = { 'darker-green': true };
          break;
        case profitLossAmount > 100:
          result = {
            'darkest-green': true,
          };
          break;
        default:
          break;
      }
    }
    return result;
  }

  navigateToJob(jobId) {
    this.router.navigate(['app/jobscreen/' + jobId]);
  }
  handleDateModeChange(e) {
    this.filterVal.filters.useJobCompletedDate.value = e.checked;
  }
  handleConfirmedFilterChange(e) {
    this.radioButtonVal = 'showConfirmed';

    this.filterVal.filters.showAll.value = false;
    this.filterVal.filters.showConfirmedOnly.value = true;
    this.filterVal.filters.showUnconfirmedOnly.value = false;
    this.search();
  }
  handleUnconfirmedFilterChange(e) {
    this.radioButtonVal = 'showUnconfirmed';

    this.filterVal.filters.showAll.value = false;
    this.filterVal.filters.showConfirmedOnly.value = false;
    this.filterVal.filters.showUnconfirmedOnly.value = true;
    this.search();
  }
  handleAllFilterChange(e) {
    this.radioButtonVal = 'showAll';

    this.filterVal.filters.showAll.value = true;
    this.filterVal.filters.showConfirmedOnly.value = false;
    this.filterVal.filters.showUnconfirmedOnly.value = false;
    this.search();
  }

  onDateChange(e) {}

  handleIncludeEngineiusChange(e) {
    this.filterVal.filters.includeEngineiusTransactions.value = e.checked;
  }

  handleUninvoicedTransactions(e) {
    this.filterVal.filters.uninvoicedTransactions.value = e.checked;
  }
}
